export default __webpack_public_path__ + "static/media/logoUberEats.d78643be.png";